import logo from './images/me-events-logo.svg';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

import 'normalize.css';
import './scss/style.scss';
import cn from 'classnames';

import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import Stefan from './pages/Stefan.js';
import Mandy from './pages/Mandy';
import Fire from './pages/Fire';
import Techniker from './pages/Techniker';
import ThankYou from './pages/ThankYou';
import Error from './pages/Error';

function App() {
  return (
    <Router>
      <div className="appWrapper">
        <header className="menu">
          <div className="container-fluid">
            <div className="row justify-between align-center">
              <div className="logo">
                <Link to="/">
                  <img src={logo} alt="ME Events Logo"/>
                </Link>
              </div>
              <nav>
                <ul>
                  <li>
                    Personalportal
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </header>
        <main className="content">
          <Switch>
            <Route path="/about">
              <h1>About</h1>
            </Route>
            <Route path="/2e970e822e1a8834203d06abb60f59ec">
              <Stefan team="ticketworker" />
            </Route>
            <Route path="/006ce4922072b1e7f8b733347fe1a40b">
              <Mandy team="kasse-gastro"/>
            </Route>
            <Route path="/2974916b686e21340f195a5cc6237a65">
              <Fire team="fire-rescue"/>
            </Route>
            <Route path="/54cdb24f1773176eb7500c1603174655">
              <Mandy team="lager"/>
            </Route>
            <Route path="/63d7a2c5d4966d49c4800d49">
              <Techniker team="techniker-hands" />
            </Route>
            <Route path="/63d7a9a0afce56f13c0c0260">
              <Mandy team="shuttle" />
            </Route>
            <Route path="/350dbfea6415451df8eb13f9">
              <Mandy team="airbeat" />
            </Route>
            <Route path="/47fc20961e2f07e36b23c26c">
              <Mandy team="indian" />
            </Route>
            <Route path="/datenschutz">
              <Datenschutz/>
            </Route>
            <Route path="/impressum">
              <Impressum/>
            </Route>
            <Route path="/vielen-dank">
              <ThankYou/>
            </Route>
            <Route path="/error">
              <Error/>
            </Route>
            <Route path="/">
              <section className="line">
                <div className="container">
                  <h1>Herzlich Willkommen</h1>
                  <p>ME-Events Personalportal.</p>
                </div>
              </section>
            </Route>
          </Switch>
        </main>
      </div>
    </Router>
  );
}

export default App;
